const FB_VERSION = "1";

export function generateFbp() {
	const timestamp = Date.now();
	const randomNumber = Math.floor(Math.random() * 1e10); // 10-digit random
	return `fb.${FB_VERSION}.${timestamp}.${randomNumber}`;
}

export function generateFbc(fbclid) {
	if (!fbclid) return null;
	const timestamp = Date.now();
	return `fb.${FB_VERSION}.${timestamp}.${fbclid}`;
}